import { combineReducers } from 'redux';

import isInit from './isInit';
import mode from './mode';

/**
 * @typedef {{
 *  isInit: boolean,
 *  mode: import('modules/global/typing/enums/modes.enum').ModeEnum
 * }} StatisticsUIDetailsReducer
 */

export default combineReducers({
  mode,
  isInit,
});
